/*!--------------------------------------------------------------------------*
 *  
 *  new-app.js
 *  
 *--------------------------------------------------------------------------*/
;
(function($, win, doc) {

  //FUTAPPS有効化
  window.MYAPP = new FUTAPPS({
    focusInfo : {
      disabled:true
    },
    winInfo : {
      h: true,
      w: true,
      t: true
    }
  });

  //==================================================
  //  init & other
  //==================================================
  ;(function() {

    MYAPP.$Wrapper = $('#AllWrapper').length>0?$('#AllWrapper'):$(null);
    MYAPP.Wrapper = document.getElementById('AllWrapper');

  })();


  //==================================================
  //  browser check
  //==================================================
  ;(function() {
    var ua = navigator.userAgent.toLowerCase();

    if(ua.indexOf("windows") > 0){
      $('html').addClass('is-windowsOS');
    }

    if(MYAPP.browser.isIE){
      $('html').addClass('is-IE');
    } else if(MYAPP.browser.isTb){
      $('html').addClass('is-tablet');
    }

    if(MYAPP.browser.isTouch){
      $('html').addClass('is-touch');
    } else {
      $('html').addClass('is-mouse');
    }
  })();


  //==================================================
  //  scrolled cls
  //==================================================
  ;(function() {

    $('html').futScrollAddClass({position:50,cls:'is-scrolled'});

  })();




  //==================================================
  //  accordion
  //==================================================
  ;(function() {

    var openCls = 'is-open';

    $('.js-accordionWrap').each(function(){
      var $wrap = $(this);

      $wrap.futAccordion( {
        btnCls: 'js-accordionButton',
        contCls: 'js-accordionCont',
        openCls: openCls,
        defaultType: 'close', // 'open' or 'close' or 'none'
        duration: 400,
        after: function() {
          if(!$wrap.hasClass(openCls)){
            $wrap.find('.js-accordionWrap').removeClass(openCls).find('.js-accordionCont').removeAttr('style');
          }
        },
        before: function() {}
      });
    });

  })();


  //==================================================
  //  clone contents
  //==================================================
  ;(function() {

    $('.js-clone[data-clone]').each(function(){

      var targetSelecter = $(this).data('clone');
      var parentSelecter = $(this).data('parent');
      var multi = $(this).data('multi');
      var htmlStr = '';

      if(targetSelecter){

        if(parentSelecter){

          var $target = $(this).parents(parentSelecter).find(targetSelecter);

        } else {
          
          var $target = $(targetSelecter);
          
        }

        if(multi){
          $target.each(function(){
            htmlStr += $(this).html();
          });
        } else {
          htmlStr = $target.eq(0).html();
        }

        $(this).html(htmlStr);

      }

    });

  })();



  //==================================================
  //  move contents
  //==================================================
  ;(function() {

    $('.js-move[data-move]').each(function(){

      var targetSelecter = $(this).data('move');
      var parentSelecter = $(this).data('parent');
      var isget = $(this).data('get');


      if(targetSelecter){

        if(parentSelecter){

          var $target = $(this).parents(parentSelecter).find(targetSelecter);

        } else {
          
          var $target = $(targetSelecter);
          
        }

        if(isget){
          $target.appendTo(this);
        } else{
          $(this).appendTo($target);
        }
      }
    });

  })();

  //==================================================
  //  replace contents
  //==================================================
  ;(function() {

    $('.js-replace[data-replace]').each(function(){

      var targetSelecter = $(this).data('replace');
      var parentSelecter = $(this).data('parent');

      if(targetSelecter){

        if(parentSelecter){

          var $target = $(this).parents(parentSelecter).find(targetSelecter);

        } else {
          
          var $target = $(targetSelecter);
          
        }

        $target = $target.eq(0);

        $(this).insertAfter($target);
        $target.remove();

      }

    });

  })();


  //==================================================
  //  target click
  //==================================================
  ;(function() {


    var $buttons = $('.js-targetClick');


    $buttons.each(function(index){

      var $button = $(this);
      var tergetSelecter;
      var $target;
      var delay = $button.data('delay');

      if($button.is('select')){

        var $selectedOption;

        $button.on('change',function(e){

          e.preventDefault();

          $selectedOption = $('option:selected',this);

          tergetSelecter = $selectedOption.data('clicktarget')?$selectedOption.data('clicktarget'):'';
          $target = tergetSelecter?$(tergetSelecter):$(null);
          if($target.length>0){
            if(delay){
              setTimeout(function(){
                $target.click();
              },delay)
            } else{
              $target.click();
            }
          }

        });

      } else{

        tergetSelecter = $button.data('clicktarget')?$button.data('clicktarget'):'';
        $target = tergetSelecter?$(tergetSelecter):$(null);
        
        if($target.length>0){

          $button.on('click',function(e){
            e.preventDefault();
            if(delay){
              setTimeout(function(){
                $target.click();
              },delay)
            } else{
              $target.click();
            }
          });

        }

      }

    });

  })();


  //==================================================
  // autoPageNavList
  //==================================================
  ;(function() {

    var $autoPageNavList = $('.js-autoPageNavList');

    $autoPageNavList.each(function(){
      var $wrap = $(this);
      var targetSelecter = $(this).data('target');
      var $target = $(null);

      if(targetSelecter){
        $target = $(targetSelecter);
      }

      $target.each(function(index){
        if(!$(this).attr('id')){
          $(this).attr('id','PageIndex'+index);
          $wrap.append('<li><a href="#PageIndex'+index+'" class="js-scroll">'+$(this).text()+'</a></li>');

        }
      });

    });

  })();

  //==================================================
  //  smooth scroll
  //==================================================
  ;(function() {

    var $Header = $('#Header');
    var adjustT = 0;

    $('a.js-scroll').futSmoothScroll({before:function(options){
      adjustT = ($Header.length>0?$Header.height():0) + 10;
      options.position = options.position-adjustT;
    }});

  })();


  //==================================================
  //  auto target blank
  //==================================================
  ;(function() {

    var $autoTargetBlank = $('.js-autoTargetBlank');

    $autoTargetBlank.find('a[href]').each(function () {

      const href = $(this).attr('href');

      if (!href) return;

      // 除外したいリンク
      if (
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('javascript:')
      ) {
        return;
      }

      // 絶対URLを生成して比較
      const url = new URL(href, window.location.origin);

      if (url.hostname !== window.location.hostname) {
        $(this).attr('target', '_blank');
        $(this).attr('rel', 'noopener noreferrer');
      }

    });

  })();

  //==================================================
  //  pc mega menu
  //==================================================
  ;(function() {

    var $navItems = $('.new-header__navList').children('li');
    var hoverCls = 'is-hov';

    function pcMenuInit() {
      $navItems.each(function(){

        $(this).hover(function(){

          $navItems.stop().clearQueue().removeClass(hoverCls);

          if(!MYAPP.browser.isTouch && $(this).find('.new-header__mega').length>0){
            $(this).addClass(hoverCls);
          }

        },function(){

          $(this).delay(300).queue(function(){
            $(this).removeClass(hoverCls);
          });

        });

      });

    }

    setTimeout(pcMenuInit,300);

  })();

  //==================================================
  //  menu
  //==================================================
  ;(function() {

    var $menuOpen = $('.js-menuOpen');
    var $menuClose = $('.js-menuClose');
    var openCls = 'is-menuOpen';
    var $Menu = $('#New-Menu');
    var currentT = 0;

    /* sp menu */
    $menuOpen.on('click',function(){

      $('html').toggleClass(openCls);

      if($('html').hasClass(openCls)){
        $Menu.scrollTop(0);
        currentT = MYAPP.winT;
      } else{
        if(currentT){
          $(win).scrollTop(currentT);
          currentT = 0;
        }
      }
      accordionReset();
    });

    $menuClose.on('click',function(){

      $('html').removeClass(openCls);
      accordionReset();

    });


    function accordionReset(){
      $Menu.find('.js-accordionWrap').removeClass('is-open').find('.js-accordionCont').removeAttr('style');
    }

  })();

  //==================================================
  // Click Toggle Class
  //==================================================
  (function(){

    let button = document.querySelectorAll(".js-toggleClass");

    function resetClass(group,parentSelector,className){
      let target;
      for (let i = 0; i < button.length; i++) {
        if(button[i].dataset.group === group){
          target = button[i];
          if(parentSelector){
            target = button[i].closest(parentSelector);
          }
          target.classList.remove(className);
         }
      }
      target = null;
    }


    function toggleClass(button){

      let target = button;
      let className = button.dataset.class;
      let parentSelector = button.dataset.parent;
      let group = button.dataset.group;
      let outclose = button.dataset.outclose;
      let outcloseTimer = null; 

      if(parentSelector){
        target = target.closest(parentSelector);
      }

      button.addEventListener("click", function(event){

        if(!target.classList.contains(className)&&group){
          resetClass(group,parentSelector,className);
        }

        if(button.classList.contains('-removeOnly')){
          target.classList.remove(className);
        } else if(button.classList.contains('-addOnly')){
          target.classList.add(className);
        } else {
          target.classList.toggle(className);
        }

        event.preventDefault();

      });


      if(outclose && MYAPP.Wrapper){

        MYAPP.Wrapper.addEventListener("click", function(event){
          clearTimeout(outcloseTimer);
          outcloseTimer = setTimeout(function(){
            target.classList.remove(className);
          },10);
        });

        target.addEventListener("click", function(event){
          setTimeout(function(){
            clearTimeout(outcloseTimer);
          },5);
        });

      }

    }




    for (let i = 0; i < button.length; i++) {
      toggleClass(button[i]);
    }


    
  })();

  //==================================================
  //  fade slider 
  //==================================================

  ;(function(){


    $('.js-fadeSwiper').each(function(){

      $(this).addClass('is-slideActive');

      var $slider = $(this);
      var $wrapper = $slider.find('.swiper-wrapper');
      var $items = $wrapper.find('.swiper-slide');

      var delay = $slider.data('delay')?$slider.data('delay'):4000;
      var speed = $slider.data('speed')?$slider.data('speed'):600;
      var random = $slider.data('random')?$slider.data('random'):false;
      var initialSlideNum = 0;

      if($items.length>=2){

        if(random){
          initialSlideNum = Math.floor(Math.random() * $items.length) ;
        }

        var swiper = new Swiper($slider, {
          loop: 1,
          effect: 'fade',
          slidesPerView: 1,
          slidesPerGroup:1,
          freeMode: false,
          speed: speed,
          threshold:10,
          draggable: false,
          initialSlide: initialSlideNum,
          pagination: {
            el: $slider.find('.swiper-pagination'),
            clickable: true,
          },
          fadeEffect: {
            crossFade: true
          },
          navigation: {
            nextEl: $slider.find('.swiper-arrow.-next'),
            prevEl: $slider.find('.swiper-arrow.-prev'),
          },
          autoplay: {
            delay: delay,
            disableOnInteraction: false,
          },
        });

        $slider.data('swiper',swiper);

      }

    });
      
  })();



  //==================================================
  //  contents slider
  //==================================================

  ;(function(){


    $.fn.slider = function(){

      $(this).each(function(){

        var $slider = $(this);
        var $wrapper = $slider.find('.swiper-wrapper');
  
        var $items = $slider.find('.swiper-slide');
  
        if($items.length===0 || $slider.hasClass('is-slideActive')) return;
  
        $slider.addClass('is-slideActive');
  
        var swiper = new Swiper($slider, {
          loop: $slider.data('loop')?true:false,
          //effect: 'fade',
          slidesPerView: 'auto',
          slidesPerGroup:1,
          freeMode: false,
          speed: 1000,
          threshold:10,
          draggable: true,
          autoplay: $slider.data('autoplay')?{
            delay: 3000,
            disableOnInteraction: false,
          }:false,
          pagination: {
            el: $slider.find('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: $slider.find('.swiper-arrow.-next'),
            prevEl: $slider.find('.swiper-arrow.-prev'),
          },
        });
  
        $wrapper.wrap('<div class="swiper-containerInner" />');

      });

    };

    $('.js-swiper').slider();
      
  })();

  //==================================================
  //  header fixed
  //==================================================
/*
  ;(function(){

    var $header = $('.new-header');
    var headerFixedCls = 'is-headerFixed';

    if($header.length===0) return;

    $(win).on('scroll.headerfixed',function(){
      if(MYAPP.winT>$header.offset().top){
        $('html').addClass(headerFixedCls);
      } else {
        $('html').removeClass(headerFixedCls);
      }
    }).trigger('scroll.headerfixed');

      
  })();
*/
  //==================================================
  //  pagetopClass
  //==================================================

  ;(function(){

    if($('.new-visual-slider').length>0){
      $('body').addClass('pg-top');
    }
      
  })();



  //==================================================
  //  custom property
  //==================================================
  ;(function() {


    $('head').append('<style id="CustomProperty"></style>');
    var $CustomProperty = $('#CustomProperty');
    var $allCustomProp = $('.js-customProp');
    var setCSS = '';
    var $target = $(null);
    var name = '';
    var css ='';
    var val = null;
    var timer  = null;


    if($allCustomProp.length===0){
      return;
    }

    $(win).on('resize.customprop load.customprop',function(){

      clearTimeout(timer);

      timer = setTimeout(function(){

        setCSS = 'html {';

        $allCustomProp.each(function(){

          $target = $(this);
          name = $target.data('name');
          css = $target.data('css');
          val = null;

          

          if($target.is(':hidden')){
            val = 0;
          } else if(css == 'height'){
            val = $target.innerHeight();
          } else if (css == 'width') {
            val = $target.innerWidth();
          } else if (css == 'top') {
            val = $target.offset().top;
          }

          if(val != null){
            setCSS += '--'+name+':'+val+'px;'
          }

        });

        setCSS += '}';

        $CustomProperty.html(setCSS);

      },20);


    }).trigger('resize.customprop');


  })();


  //==================================================
  //  prepend Text Input
  //==================================================
  ;(function() {
    $('.js-prependTextInput').each(function(){
      var $input = $(this); 
      var $label = $input.parents('label');
      var targetSelector = $input.data('target');
      var $target = $label.length>0 && targetSelector ? $(targetSelector) : $(null) ;
      var setText;
      var targetVal;
      $input.on('change',function(){
        targetVal = $target.val();
        setText = '・' + $label.text();
        if($input.is(':checked') && targetVal.indexOf(setText) === -1){
          $target.val($target.val()+(targetVal?'\n':'')+setText);
          $target.scrollTop($target.get(0).scrollHeight);
        } else if(!$input.is(':checked') && targetVal.indexOf(setText) > -1) {
          $target.val(targetVal.replaceAll('\n'+setText,'').replaceAll(setText,''));
        }
      });
    });
  })();



  //==================================================
  // product alt set
  //==================================================
  ;(function() {
    var $wrap = $('.product__media-wrapper .product__media-list');
    var $title = $('.product__title');

    $wrap.each(function(){
      var $item = $(this).find('.product__media');
      $item.each(function(){
        var alt = $(this).find('img').eq(0).attr('alt');
        if($title.text()!=alt && alt){
          $(this).append('<div class="u-pb5 u-pt5 u-pl10 u-pr10" style="bottom:0;top:auto; height:auto;background:rgba(255,255,255,.5);"><small>'+alt+'</small></div>');
        }
      });
    });
  })();


  //==================================================
  // colorLink
  //==================================================
  ;(function() {
    var $wrap = $('.js-colorLinkWrap');
    var setColor = '';
    var colorName = '';

    $wrap.find('a').each(function(){
      setColor = $(this).text().match(/#[A-Fa-f0-9]{6}/);
      if(setColor && setColor[0]){
        setColor = setColor[0];
        colorName = $(this).text().replaceAll(setColor,'').trim();
        $(this)
          .html('<span>'+colorName+'</span>')
          .attr('title',colorName)
          .css('background-color',setColor)
      }
    });
  })();



  //==================================================
  // colorLink
  //==================================================
  ;(function() {
    var $japaneseJudge = $('.js-japaneseJudge');
    var japaneseCls  = 'is-japanese';
    var notJapaneseCls  = 'is-notJapanese';

    $japaneseJudge.each(function(){
      var text = $(this).text();
      if (/[ぁ-んァ-ン一-龯]/.test(text)) {
        $(this).addClass(japaneseCls);
      } else {
        $(this).addClass(notJapaneseCls);
      }
    });

  })();


  //==================================================
  // iframe aspect-ratio
  //==================================================
  ;(function() {

    var $iframe = $('.rte iframe');

    $iframe.each(function(){
      if($(this).attr('width') && $(this).attr('height')){
        $(this).css({'aspect-ratio':$(this).attr('width')+'/'+$(this).attr('height')});
      }
    });

  })();






})(jQuery, window, document);

